<template>
    <div>
      <el-card>
        <div class="itemTitle" >警报点节点信息</div>
        <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
          <!--<el-form-item label="编号">-->
          <!--<span >{{alarmPointInfo.alarmPointId}}</span>-->
          <!--</el-form-item>-->
          <div class="tonghang" >
            <el-form-item label="点位名称">
              <span>{{AlarmPointStaticInfomation.pointName  === "" ? '无': AlarmPointStaticInfomation.pointName }}</span>
            </el-form-item>
            <el-form-item label="台站类型">
              <span>{{AlarmPointStaticInfomation.alarmPointType  === "" ? '无': AlarmPointStaticInfomation.alarmPointType }}</span>
            </el-form-item>
          </div>

          <div class="tonghang" >
            <el-form-item label="纬度">
              <span>{{AlarmPointStaticInfomation.longitude  === "" ? '无': AlarmPointStaticInfomation.longitude }}</span>
            </el-form-item>
            <el-form-item label="经度">
              <span>{{AlarmPointStaticInfomation.latitude  === "" ? '无': AlarmPointStaticInfomation.latitude }}</span>
            </el-form-item>
          </div>

          <div class="tonghang" >
            <el-form-item label="区域ID">
              <span>{{AlarmPointStaticInfomation.areaName === "" ? '无': AlarmPointStaticInfomation.areaName }}</span>
            </el-form-item>
            <el-form-item label="警音半径">
              <span>{{AlarmPointStaticInfomation.alarmRadius  === "" ? '无': AlarmPointStaticInfomation.alarmRadius }}</span>
            </el-form-item>
          </div>

          <div class="tonghang" >
            <el-form-item label="安装时间">
              <span>{{AlarmPointStaticInfomation.installAt  === "" ? '无': AlarmPointStaticInfomation.installAt }}</span>
            </el-form-item><br>
            <el-form-item label="备注">
              <span>{{AlarmPointStaticInfomation.remark  === "" ? '无': AlarmPointStaticInfomation.remark }}</span>
            </el-form-item>
          </div>

        </el-form>
        <div class="itemTitle" >警报器信息</div>
        <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
          <div class="tonghang">
            <el-form-item label="生产厂家">
              <span>{{alarmerInformation.producer  === "" ? '无': alarmerInformation.producer }}</span>
            </el-form-item>
            <el-form-item label="设备型号">
              <span>{{alarmerInformation.type  === "" ? '无': alarmerInformation.type }}</span>
            </el-form-item>
          </div>

          <div class="tonghang">
            <el-form-item label="版本">
              <span>{{alarmerInformation.version  === "" ? '无': alarmerInformation.version }}</span>
            </el-form-item>
            <el-form-item label="功率">
              <span>{{alarmerInformation.power === "" ? '无': alarmerInformation.power }}</span>
            </el-form-item>
          </div>

          <div class="tonghang">
            <el-form-item label="安装者">
              <span>{{alarmerInformation.installer === "" ? '无': alarmerInformation.installer }}</span>
            </el-form-item>
            <el-form-item label="安装时间">
              <span>{{alarmerInformation.installAt === "" ? '无': alarmerInformation.installAt }}</span>
            </el-form-item>
          </div>

          <div class="tonghang">
            <el-form-item label="备注">
              <span>{{alarmerInformation.remark === "" ? '无': alarmerInformation.remark }}</span>
            </el-form-item>
          </div>
        </el-form>
        <div class="itemTitle">警报控制器信息</div>
        <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
          <div class="tonghang">
            <el-form-item label="生产厂家">
              <span>{{alarmControllerInformation.producer === "" ? '无': alarmControllerInformation.producer }}</span>
            </el-form-item>
            <el-form-item label="通信体制">
              <span>{{alarmControllerInformation.communicationSystem === "" ? '无': alarmControllerInformation.communicationSystem }}</span>
            </el-form-item>
          </div>

          <div class="tonghang">
            <el-form-item label="版本">
              <span>{{alarmControllerInformation.version === "" ? '无': alarmControllerInformation.version }}</span>
            </el-form-item>
            <el-form-item label="地址码">
              <span>{{alarmControllerInformation.addressCode === "" ? '无': alarmControllerInformation.addressCode }}</span>
            </el-form-item>
          </div>

          <div class="tonghang">
            <el-form-item label="电台型号">
              <span>{{alarmControllerInformation.radioType === "" ? '无': alarmControllerInformation.radioType }}</span>
            </el-form-item>
            <el-form-item label="安装者">
              <span>{{alarmControllerInformation.installer === "" ? '无': alarmControllerInformation.installer }}</span>
            </el-form-item>
          </div>

          <div class="tonghang">
            <el-form-item label="安装时间">
              <span>{{alarmControllerInformation.installAt === "" ? '无': alarmControllerInformation.installAt }}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span>{{alarmControllerInformation.remark === "" ? '无': alarmControllerInformation.remark }}</span>
            </el-form-item>
          </div>
        </el-form>
        <div class="itemTitle" >物联网检测终端信息</div>
        <el-form label-position="left" inline class="demo-table-expand" :label-position="labelPosition">
          <div class="tonghang">
            <el-form-item label="生产厂家">
              <span>{{monitorInformation.producer === "" ? '无': monitorInformation.producer }}</span>
            </el-form-item>
            <el-form-item label="安装者">
              <span>{{monitorInformation.installer === "" ? '无': monitorInformation.installer}}</span>
            </el-form-item>
          </div>

          <div class="tonghang">
            <el-form-item label="设备型号">
              <span>{{monitorInformation.type === "" ? '无': monitorInformation.type}}</span>
            </el-form-item>
            <el-form-item label="物联卡号">
              <span>{{monitorInformation.ICCID === "" ? '无': monitorInformation.ICCID}} </span>
            </el-form-item>
          </div>
          <div class="tonghang">
            <el-form-item label="安装时间">
              <span> {{monitorInformation.installAt === "" ? '无': monitorInformation.installAt}}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span>{{monitorInformation.remark === "" ? '无': monitorInformation.remark}}</span>
            </el-form-item>
          </div>
        </el-form>
      </el-card>
    </div>
</template>

<script>
  export default {
    name: 'AlarmPointInfo',
    props:['alarmPointId'],
    data(){
      return {
        labelPosition:'right',
        // 查看警报点静态信息
        GetStaticInformation:{
          "version": 1,
          "method": "alarmpoint2.GetStaticInformation",
          "params": {
            "alarmPointId":"#"
          },
          "token": "#",
          "id": 0
        },
        // 警报点静态信息
        AltStaticInformation:{
          "version":"1.0",
          "result":{
            "_id":"5dc8d7dfd7693b3c280ee0a1",
            "areaId":"0601",
            "areaName":"",
            "pointName":"",
            "alarmPointType":"",
            "latitude":"",
            "longitude":"",
            "alarmRadius":"",
            "installAt":"",
            "deletedFlag":"",
            "remark":"",
            "devID":"",
            "monitorInformation":{
              "producer":"",
              "type":"",
              "ICCID":"",
              "installAt":"",
              "installer":"",
              "remark":"",
              "version":""
            },
            "alarmerInformation":{
              "producer":"",
              "type":"",
              "version":"",
              "power":"",
              "installer":"",
              "installAt":"",
              "remark":""
            },
            "alarmControllerInformation":{
              "producer":"",
              "communicationSystem":"",
              "version":"",
              "addressCode":"",
              "radioType":"",
              "installAt":"",
              "installer":"",
              "remark":""
            }
          },
          "id":0
        }
      }
    },
    methods:{
      // 获取警报点静态数据
      getStaticInfomation(){
        this.GetStaticInformation.token = this.$store.state.token;
        console.log('查看警报点静态信息请求');
        console.log(this.GetStaticInformation);
        this.$axios.post(this.$mainUrl, this.GetStaticInformation).then(res=>{
          console.log('查看警报点静态信息请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.AltStaticInformation = res.data.result;
          }else{
            this.$message({
              type:'error',
              message: '获取警报点信息失败，' + res.data.error.message
            })
          }
        })
      },
    },
    watch:{
      alarmPointId(newValue, oldValue){
        if(newValue !== null && newValue !== ""){
          // 为空则不用刷新
          this.GetStaticInformation.params.alarmPointId = newValue;
          this.getStaticInfomation();
        }
        else{
          Object.keys(this.AlarmPointStaticInfomation).forEach(key =>{
            if(key !== "alarmerInformation" && key !== "alarmControllerInformation" && key !== "monitorInformation"){
              this.AlarmPointStaticInfomation[key] = "";
            }
          })
          Object.keys(this.alarmerInformation).forEach(key =>{
            this.alarmerInformation[key] = "";
          })
          Object.keys(this.alarmControllerInformation).forEach(key =>{
            this.alarmControllerInformation[key] = "";
          })
          Object.keys(this.monitorInformation).forEach(key =>{
            this.monitorInformation[key] = "";
          })
        }

      }
    },
    computed:{
      AlarmPointStaticInfomation(){
        return this.AltStaticInformation;
      },
      alarmerInformation(){
        if(this.AltStaticInformation.hasOwnProperty('alarmerInformation')){
          return this.AltStaticInformation.alarmerInformation;
        }else{
          return {
            producer:'', type:'', version:'', power:'', installer:'', installAt:'', remark:''
          }
        }

      },
      alarmControllerInformation(){
        if(this.AltStaticInformation.hasOwnProperty('alarmControllerInformation')){
          return this.AltStaticInformation.alarmControllerInformation;
        }else{
          return {
            producer:'', communicationSystem:'', version:'', addressCode:'', radioType:'', installAt:'', installer:'', remark:''
          }
        }
      },
      monitorInformation(){
        if(this.AltStaticInformation.hasOwnProperty('monitorInformation')){
          return this.AltStaticInformation.monitorInformation;
        }else{
          return {
            producer:'', type:'', ICCID:'', installAt:'', installer:'', remark:''
          }
        }
      }
    }
  }
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .tonghang{
    display: flex;
    flex-wrap: nowrap;
  }
  .itemTitle{
    margin-top: 10px;
    width: 100%;
    text-align: center;
    font-size: 18px;
    line-height: 30px;
    font-family: 黑体;

  }
</style>
